module.exports = __webpack_public_path__ + "media/images/map-394d8d71a9fc71c56b801be3566bb34f.jpg";